import MemLearning from '@memrise/memlearning';
import { convertMemlearningStateToDomain } from './conversion';
import { SetSessionState } from './presenter';

export type PresentSummary = (state: {
  endOfSessionPoints: number;
}) => void;

class Subscriber {
  constructor(
    private updateSessionStateForStore: SetSessionState,
    private presentSummary: PresentSummary,
    private onMemlearningError: (error: Error) => void,
  ) { }

  updateState(state: MemLearning.com.memrise.learning.session.SessionState) {
    const sessionState = convertMemlearningStateToDomain(state, this.presentSummary);
    if (sessionState) {
      this.updateSessionStateForStore(sessionState);
    }
  }

  updateOnError(error: Error) {
    this.onMemlearningError(error)
  }
}

export const makeSubscriber = (updateSessionStateForStore: SetSessionState,
  presentSummary: PresentSummary,
  onMemlearningError: (error: Error) => void) => new Subscriber(updateSessionStateForStore, presentSummary, onMemlearningError);
